<app-common-page-breadcrumbs [navigationData]="navigationData" [pageTitle]="title">
</app-common-page-breadcrumbs>
<div *ngIf="enableLoader" id="loader"></div>
<div>
  <div class="container d-flex justify-content-center" *ngIf="masterDataModel">
    <div class="d-flex justify-content-center" *ngIf="!enableLoader">
      <ng-container>
        <form (ngSubmit)="submitForm()" class="mt-5 mb-5" [formGroup]="addcontactform">
          <div class="form-row">
            <div class="form-group mt-3 col-md-2">
              <label for="Salutation">{{'heading.Salutation' | cxTranslate}}</label>
              <select id="Salutation" class="form-control form-control-lg input pl-1" formControlName="titleCode">
                <option class="input" *ngFor="let sal of masterDataModel.titles" value="{{sal.code}}">{{sal.name}}
                </option>
              </select>
            </div>
            <div class="form-group mt-3 col-md-5">
              <label for="Firstname">{{'heading.Firstname' | cxTranslate}}</label>
              <input type="text" class="form-control form-control-lg input" id="Firstname" formControlName="firstName" maxlength="40">
              <p *ngIf="addcontactform.controls.firstName.errors?.required && addcontactform.controls.firstName.dirty"
                class="text-danger f-14">{{'home.validation.Field' | cxTranslate}} </p>
              <p *ngIf="addcontactform.controls.firstName.errors?.pattern && addcontactform.controls.firstName.dirty"
                class="text-danger f-14"> {{'home.validation.special' | cxTranslate}}</p>


            </div>
            <div class="form-group mt-3 col-md-5">
              <label for="Lastname">{{'heading.Lastname' | cxTranslate}}</label>
              <input type="text" class="form-control form-control-lg input" id="Lastname" formControlName="lastName" maxlength="40">
              <p *ngIf="addcontactform.controls.lastName.errors?.required && addcontactform.controls.lastName.dirty"
                class="text-danger f-14">{{'home.validation.Field' | cxTranslate}}</p>
              <p *ngIf="addcontactform.controls.lastName.errors?.pattern && addcontactform.controls.lastName.dirty"
                class="text-danger f-14"> {{'home.validation.special' | cxTranslate}}</p>
            </div>
          </div>
          <div class="form-group mt-3 mb-3">
            <label for="Email">{{'heading.E-mail*' | cxTranslate}}</label>
            <input type="email" class="form-control form-control-lg input" id="Email" formControlName="email" (focus)="hideError()">
            <p *ngIf="addcontactform.controls.email.errors?.required && addcontactform.controls.email.dirty"
              class="text-danger f-14">{{'home.validation.Field' | cxTranslate}}</p>
            <p *ngIf="addcontactform.controls.email.errors?.pattern && addcontactform.controls.email.dirty"
              class="text-danger f-14"> {{'home.validation.email' | cxTranslate}}</p>
            <p *ngIf="this.userIdExist" class="text-danger f-14"> {{errorMessageForEmail}}</p>
          </div>
          <div class="form-group mt-4 mb-3">
            <label for="Mobile"> {{'heading.Mobile' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="Mobile" formControlName="mobileNumber" maxlength="40">
            <p *ngIf="addcontactform.controls.mobileNumber.errors?.pattern && addcontactform.controls.mobileNumber.dirty"
              class="text-danger f-14">{{'home.validation.mobile' | cxTranslate}}</p>

          </div>
          <div class="form-group mt-4 mb-3">
            <label for="AlternateNumber"> {{'heading.AlternateNumber' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="AlternateNumber" formControlName="alternateNumber"
              maxlength="40">
            <p *ngIf="addcontactform.controls.alternateNumber.errors?.pattern && addcontactform.controls.alternateNumber.dirty"
              class="text-danger f-14">{{'home.validation.mobile' | cxTranslate}}</p>
          </div>
          <div class="form-group mt-4 mb-3">
            <label for="jobTitle"> {{'heading.Designatedcontact' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="jobTitle" formControlName="jobTitle" maxlength="40">
          </div>
          <div class="form-group mt-3 mb-3">
            <label for="Department"> {{'heading.Department' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="Department" formControlName="department" maxlength="80">
          </div>
          <!-- <div class="form-group mt-3 mb-3">
            <label for="personalLinked"> {{'heading.personalLinked' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="personalLinked" formControlName="linkedInProfile" maxlength="255">
          </div> -->
          <!-- user role -->
          <label> {{'heading.Role' | cxTranslate}}</label>
          <ng-select  [items]="masterDataModel.userRole" [multiple]="true" [clearable]="false" bindLabel="description" dropdownPosition="bottom" groupBy="code"
          placeholder="{{ 'heading.SelectRole' | cxTranslate }}" [selectableGroup]="false"
          [closeOnSelect]="true" bindValue="code" [(ngModel)]="userRoles" [ngModelOptions]="{standalone: true}"
          notFoundText="{{'heading.NoItemsFound' | cxTranslate }}">
          <ng-template ng-multi-label-tmp>
            <span class="filter-count pl-2 text-black">{{userRoles.length}}x {{ 'heading.SelectedRoles' | cxTranslate }}</span>
          </ng-template>
         
          <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
            class="dropdown-ng-template">
            <input type="checkbox" /> 
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
           <div>
            <input (click)="selectUserRole(item, item$.selected)" id="{{item.code}}" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" [checked]="item.checked"  type="checkbox"
               /> <span>{{item.description}}</span>
            </div> 
          </ng-template>
           <!-- commodity type -->
        </ng-select> 
          <label class="mt-4"> {{'heading.Commodity' | cxTranslate}}</label>
        <ng-select  [items]="masterDataModel.commodityType" [multiple]="true" [clearable]="false" bindLabel="description" dropdownPosition="bottom" groupBy="id"
           placeholder="{{ 'heading.SelectCommodity' | cxTranslate }}" [selectableGroup]="false"
           [closeOnSelect]="true" bindValue="id" [(ngModel)]="commodityTypes" [ngModelOptions]="{standalone: true}"
           notFoundText="{{'heading.NoItemsFound' | cxTranslate }}">
           <ng-template ng-multi-label-tmp>
             <span class="filter-count pl-2 text-black">{{commodityTypes.length}}x {{ 'heading.SelectedTypestypes' | cxTranslate }}</span>
           </ng-template>
           <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
             class="dropdown-ng-template">
             <input type="checkbox" /> 
           </ng-template>
           <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div>
             <input (click)="selectCommodity(item, item$.selected)" id="{{item.id}}" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" [checked]="item.checked"  type="checkbox"
                /> <span>{{item.description}}</span>
             </div> 
           </ng-template>
         </ng-select> 

          <hr>
          <h5 class="strong"> {{'heading.ShoppingDetails' | cxTranslate}}</h5>
          <div class="form-check" *ngFor="let mod of masterDataModel.modeOfContacts;let i = index">
            <input class="form-check-input bg-white input text-dark" type="radio" id="mot{{i}}" name="modeOfContact"
              formControlName="modeOfContact" value="{{mod.id}}">
            <label class="form-check-label input text-dark" for="mot{{i}}">
              {{mod.name}}
            </label>
          </div>
          <hr>
          <h5 class="strong">{{'heading.BhpConnect' | cxTranslate}}</h5>
          <div class="form-check">
            <input class="form-check-input bg-white input text-dark" type="radio" name="accessIndicator"
              formControlName="accessIndicator" value=true>
            <label for="AI0" class="form-check-label input text-dark">
              {{'heading.yes' | cxTranslate}}
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input bg-white input text-dark" type="radio" name="accessIndicator"
              formControlName="accessIndicator" value=false>
            <label for="AI1" class="form-check-label input text-dark">
              {{'heading.no' | cxTranslate}}
            </label>
          </div>
          <div class="form-group mt-5 mb-3">
            <button class="btn btn-block btn-primary btn-lg" type="submit" (click)="createcontact(addcontactform.value)"
              [disabled]="!admin|| isDisabled|| !addcontactform.valid" *ngIf="admin">
              {{'heading.Save' | cxTranslate}}
            </button>

            <button class="btn btn-block btn-secondary btn-lg" type="submit" (click)="navigateToLandingPage()"
              [disabled]="!admin" *ngIf="admin">
              {{'heading.Cancel' | cxTranslate}}
            </button>
            <button class="btn btn-block btn-secondary btn-lg" [routerLink]="{ cxRoute : 'contacts' } | cxUrl"
              (click)="sendMessage()" *ngIf="!admin">
              {{'heading.Back' | cxTranslate}}
            </button>

          </div>
        </form>

      </ng-container>

    </div>
  </div>